import React, {useRef, useState} from 'react';
import {ICONS} from "@/constants";
import ReactPlayer from "react-player/lazy";
import styled from "styled-components";
import Icon from "@/components/common/Icon/Icon";
import CommonImage, {formatImageCMSData} from "@/components/common/Image";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {getPropSafely} from "@/utils/utils";

const Wrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
    aspect-ratio: 16/9;
`

const Image = styled(CommonImage)`
	position: absolute;
    cursor: pointer;
	width: 100%;
	height: 100%;
`

const Play = styled(Icon)`
	--size: 10vw;
	position: absolute;
	top: 50%;
	left: 50%;
	translate: -50% -50%;
	display: flex;
	align-items: center;
	justify-content: center;
	width: var(--size);
    height: var(--size);
	//aspect-ratio: 1;
	border-radius: 50%;
	background: ${({theme}) => theme.colors.white};
	padding: calc(var(--size)/3);
	cursor: pointer;
	z-index: 10;
	
    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        //--size: 7.5%;
        --size: 7.5vw;
    }
`

const VideoWithCover = ({ data={}, sizes='100%', className='' }) => {
	const PlayerRef = useRef()
	const cover = getPropSafely(data, 'cover')
	const videoUrl = getPropSafely(data?.externalVideoUrl, 'url', '')
	const image = formatImageCMSData(cover?.image)
	const [playingStarted, setPlayingStarted] = useState(false)

	const handleStartPlaying = () => {
		setPlayingStarted(true)
	}

	// useEffect(() => {
	// logNamed({ playingStarted })
	// }, [playingStarted]);

	return (
		<Wrapper className={`video-with-cover ${className}`} >
			{(!Boolean(image.url) && !playingStarted) && (
				<Play name={ICONS.PLAY} onClick={handleStartPlaying}/>
			)}
			<ReactPlayer
				ref={PlayerRef}
				url={videoUrl}
				width="100%"
				height="100%"
				controls
				playsinline
				playing={playingStarted}
				onStart={handleStartPlaying}
				light={image.url ? (
					<Image
						src={image.url}
						alt={image.alt}
						focalPoint={image.focalPoint}
						placeholder={image.placeholder}
						showMetaData={image.showMetaData}
						sizes={sizes}
						onClick={handleStartPlaying}
					/>
				) : null}
				playIcon={<Play name={ICONS.PLAY} onClick={handleStartPlaying}/>}
			/>
		</Wrapper>
	);
};

export default VideoWithCover;
